// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.company-search-wrapper {
  position: relative;
  width: 100%;
}
.company-search-wrapper .search-spinner {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  pointer-events: none;
}
.company-search-wrapper .dropdown-search-result.absolute {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  min-width: 0;
  margin: 0;
  z-index: 1050;
}
.company-search-wrapper .dropdown-search-result.absolute .dropdown-item {
  white-space: normal;
  word-break: break-word;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
